/***********************/
/* Angular + external */
import { Component, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";
/***********************/
import { BfxDialogData } from "./models/bfx-dialog-data.model";
// components
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
// services

import { LoggerService } from "@bfx/logger";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";
const logger = LoggerService.for(__dirname);

/**
 * Generic Fwd Roll dialog presenting a Save/Abort/Canel dialog
 *
 */
@Component({
  selector: `bfx-dialog-fwd-roll-replace`,
  templateUrl: `./html/bfx-dialog-fwd-roll-replace.html`,
  standalone: false,
})
export class BfxDialogFwdRollReplaceComponent extends BfxDialogBaseComponent {
  /***************************************/
  /* DATA */

  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 550,
      title_text: "TITLE",
      message_text: "MESSAGE",
      save_operation_button: "Save & open Def",
      abort_operation_button: "Abort & open Def",
      cancel_button: "Cancel def",
    },
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private _translate: TranslateService,
    protected _element: ElementRef,
  ) {
    super();
  }

  /**********************************************************************/
  /* OPEN DIALOG */
  public openDialog(_dialogData: BfxDialogData): Observable<any> {
    try {
      this.data.dialogId = _dialogData.dialogId;
      this.data.actionEvent = _dialogData.event;
      this.data.payload = _dialogData.payload;

      if (
        typeof _dialogData?.payload?.callbacks?.saveOperation !== "function" &&
        typeof _dialogData?.payload?.callbacks?.abortOperation !== "function" &&
        typeof _dialogData?.payload?.callbacks?.cancel !== "function"
      ) {
        logger.out.error("Illegal callbacks specified for payload");
      }
      if (_dialogData.payload != null) {
        if (this.data.payload.isExit) {
          this.data.dialogData.title_text = this._translate.instant("fwd_roll.exit.title", []);
          this.data.dialogData.message_text = this._translate.instant("fwd_roll.exit.message", [
            this.data.payload?.currentPortfolioId?.toString(),
          ]);

          this.data.dialogData.save_operation_button = this._translate.instant(
            "fwd_roll.exit.save_exit_button",
          );
          this.data.dialogData.abort_operation_button = this._translate.instant(
            "fwd_roll.exit.abort_exit_button",
          );
        } else {
          this.data.dialogData.title_text = this._translate.instant("fwd_roll.open_new.title", [
            this.data.payload?.newPortfolioId?.toString(),
          ]);
          this.data.dialogData.message_text = this._translate.instant("fwd_roll.open_new.message", [
            this.data.payload?.currentPortfolioId?.toString(),
          ]);

          this.data.dialogData.save_operation_button = this._translate.instant(
            "fwd_roll.open_new.save_operation_button",
          );
          this.data.dialogData.abort_operation_button = this._translate.instant(
            "fwd_roll.open_new.abort_operation_button",
          );
        }
        this.data.dialogData.cancel_button = this._translate.instant(
          "fwd_roll.open_new.cancel_button",
        );
      }
      this.data.dialogData.show = true;
      NativeDesktopSupport.prepareEmbeddedDialog(_dialogData.body, this._dialog, this._element);
    } catch (ex) {
      logger.out.error(
        "ERROR: BfxDialogOrderCancelConfirmComponent.openDialog(): Dialog exception! msg:",
        ex,
      );
    }

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    if (typeof this.data.payload?.callbacks?.cancel === "function") {
      this.data.payload.callbacks.cancel();
    }

    super.closeDialog();

    this.data.dialogData.title_text = null;
    this.data.dialogData.message_text = null;
    this.data.actionEvent = null;
    this.data.payload = null;
    this.data.dialogData.show = false;

    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  /**********************************************************************/
  public saveOperation(): void {
    if (typeof this.data.payload?.callbacks?.saveOperation === "function") {
      this.data.payload.callbacks.saveOperation();
    }
    this.data.payload = null;
    this.closeDialog();
  }
  public abortOperation(): void {
    if (typeof this.data.payload?.callbacks?.abortOperation === "function") {
      this.data.payload.callbacks.abortOperation();
    }
    this.data.payload = null;
    this.closeDialog();
  }
  public cancel(): void {
    if (typeof this.data.payload?.callbacks?.cancel === "function") {
      this.data.payload.callbacks.cancel();
    }
    this.data.payload = null;
    this.closeDialog();
  }
}
